import { Controller, UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { LoanFormData } from '@/schemas/loanSchema';

interface AdvancedFieldsSectionProps {
  form: UseFormReturn<LoanFormData>;
}

export function AdvancedFieldsSection({ form }: AdvancedFieldsSectionProps) {
  const { control } = form;

  return (
    <div className="p-8 mb-8" data-test-id="advanced-fields-section">
      <h4
        className="text-lg font-semibold mb-6 mt-8 text-primary-dark"
        data-test-id="additional-fields-heading"
      >
        Additional Fields
      </h4>
      <div
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
        data-test-id="additional-fields-container"
      >
        <div className="loanform-group" data-test-id="field-x1-field">
          <Label
            className="form-label loanform-label"
            htmlFor="additional_fields.x1"
            data-test-id="field-x1-label"
          >
            Field X1
          </Label>
          <Controller
            name="additional_fields.x1"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                className="form-input loanform-input"
                data-test-id="field-x1-input"
                value={field.value ?? ''}
              />
            )}
          />
        </div>
        <div className="loanform-group" data-test-id="field-x2-field">
          <Label
            className="form-label loanform-label"
            htmlFor="additional_fields.x2"
            data-test-id="field-x2-label"
          >
            Field X2
          </Label>
          <Controller
            name="additional_fields.x2"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                className="form-input loanform-input"
                data-test-id="field-x2-input"
                value={field.value ?? ''}
              />
            )}
          />
        </div>
        <div className="loanform-group" data-test-id="field-x3-field">
          <Label
            className="form-label loanform-label"
            htmlFor="additional_fields.x3"
            data-test-id="field-x3-label"
          >
            Field X3
          </Label>
          <Controller
            name="additional_fields.x3"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                className="form-input loanform-input"
                data-test-id="field-x3-input"
                value={field.value ?? ''}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
